(function () {
  function setupSlider(root) {
    var track = root.querySelector('[data-hoov-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hoov-slide]'));
    var dotsContainer = root.querySelector('[data-hoov-dots]');
    var prevBtn = root.querySelector('[data-hoov-prev]');
    var nextBtn = root.querySelector('[data-hoov-next]');

    if (!track || slides.length === 0) return;

    var activeIndex = 0;
    var stepCount = 1;
    var dots = [];

    function slideStep() {
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function visibleCount() {
      var step = slideStep();
      if (step <= 0) return 1;
      return Math.max(1, Math.round(track.clientWidth / step));
    }

    function buildDots() {
      stepCount = Math.max(1, slides.length - visibleCount() + 1);

      dotsContainer.innerHTML = '';
      dots = [];
      for (var i = 0; i < stepCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hoov-slider__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (index) {
          dot.addEventListener('click', function () {
            goTo(index);
          });
        })(i);
        dotsContainer.appendChild(dot);
        dots.push(dot);
      }

      if (activeIndex > stepCount - 1) {
        activeIndex = stepCount - 1;
      }
      updateActive(activeIndex);
    }

    function wrap(index) {
      return ((index % stepCount) + stepCount) % stepCount;
    }

    function updateActive(index) {
      activeIndex = wrap(index);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
      });
    }

    function closestIndexToScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var closestDistance = Infinity;
      slides.forEach(function (slide, i) {
        if (i > stepCount - 1) return;
        var distance = Math.abs(slide.offsetLeft - track.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = i;
        }
      });
      return closest;
    }

    function goTo(index) {
      index = wrap(index);
      var target = slides[index];
      track.scrollTo({
        left: target.offsetLeft - track.offsetLeft,
        behavior: 'smooth',
      });
      updateActive(index);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
      });
    }

    if (root.hasAttribute('data-hoov-autoplay')) {
      var autoplayInterval = parseInt(root.getAttribute('data-hoov-autoplay'), 10) || 3000;
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplayTimer = null;

      var stopAutoplay = function () {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      var startAutoplay = function () {
        if (prefersReducedMotion || stepCount <= 1 || autoplayTimer) return;
        autoplayTimer = setInterval(function () {
          goTo(activeIndex + 1);
        }, autoplayInterval);
      };

      if (!prefersReducedMotion) {
        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);
        root.addEventListener('touchstart', stopAutoplay, { passive: true });
        root.addEventListener('focusin', stopAutoplay);
        root.addEventListener('focusout', startAutoplay);
      }
    }

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        updateActive(closestIndexToScroll());
      }, 100);
    });

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(buildDots, 150);
    });

    buildDots();
    window.addEventListener('load', buildDots);

    if (root.hasAttribute('data-hoov-autoplay')) {
      startAutoplay();
    }
  }

  var initialized = new WeakSet();

  function initOne(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    setupSlider(root);
  }

  function init() {
    document.querySelectorAll('[data-hoov-slider]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sliders injected later (e.g. AJAX product recommendations) are picked up automatically.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-hoov-slider]')) initOne(node);
        if (node.querySelectorAll) node.querySelectorAll('[data-hoov-slider]').forEach(initOne);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
